import { useEffect, useRef, useState } from 'react';
import api from '../api/axios';

let cacheGlobal = null;

export default function PecaAutocomplete({ value, onChange, onSugestao, placeholder = 'Descrição da peça', className = '' }) {
  const [todas, setTodas] = useState([]);
  const [lista, setLista] = useState([]);   // itens exibidos no dropdown
  const [aberto, setAberto] = useState(false);
  const [indice, setIndice] = useState(-1);
  const inputRef = useRef(null);

  useEffect(() => {
    if (cacheGlobal) { setTodas(cacheGlobal); return; }
    api.get('/servicos/pecas-sugestoes').then(r => {
      cacheGlobal = r.data;
      setTodas(r.data);
    }).catch(() => {});
  }, []);

  // Atualiza lista: campo vazio → top 8 mais usadas; digitando → filtra
  useEffect(() => {
    if (!value || value.trim().length === 0) {
      setLista(todas.slice(0, 8));
    } else if (value.trim().length >= 2) {
      const q = value.trim().toLowerCase();
      setLista(todas.filter(s => s.descricao.toLowerCase().includes(q)).slice(0, 8));
    } else {
      setLista([]);
    }
    setIndice(-1);
  }, [value, todas]);

  const selecionar = (item) => {
    onChange(item.descricao);
    if (onSugestao) onSugestao(item);
    setAberto(false);
    inputRef.current?.blur();
  };

  const handleKeyDown = (e) => {
    if (!aberto || lista.length === 0) return;
    if (e.key === 'ArrowDown') { e.preventDefault(); setIndice(i => Math.min(i + 1, lista.length - 1)); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); setIndice(i => Math.max(i - 1, 0)); }
    else if (e.key === 'Enter' && indice >= 0) { e.preventDefault(); selecionar(lista[indice]); }
    else if (e.key === 'Escape') { setAberto(false); }
  };

  const mostrarDropdown = aberto && lista.length > 0;

  return (
    <div className="relative">
      <input
        ref={inputRef}
        type="text"
        value={value}
        onChange={e => onChange(e.target.value)}
        onKeyDown={handleKeyDown}
        onFocus={() => setAberto(true)}
        onBlur={() => setTimeout(() => setAberto(false), 150)}
        placeholder={placeholder}
        autoComplete="off"
        className={className}
      />

      {mostrarDropdown && (
        <ul className="absolute z-50 left-0 right-0 mt-1 bg-white border border-gray-200 rounded-xl shadow-lg max-h-56 overflow-y-auto">
          {/* Cabeçalho quando campo está vazio */}
          {(!value || value.trim().length === 0) && (
            <li className="px-3 pt-2 pb-1">
              <span className="text-xs font-medium text-gray-400 uppercase tracking-wide">Mais usadas</span>
            </li>
          )}
          {lista.map((item, i) => (
            <li
              key={item.descricao}
              onMouseDown={() => selecionar(item)}
              className={`flex items-center justify-between px-3 py-2.5 cursor-pointer transition-colors ${
                i === indice ? 'bg-blue-50' : 'hover:bg-gray-50'
              }`}
            >
              <div className="flex items-center gap-2 min-w-0">
                <span className="text-sm text-gray-800 truncate">{item.descricao}</span>
                <span className="text-xs text-gray-400 shrink-0">{item.usos}x</span>
              </div>
              {item.ultimoValor && (
                <span className="text-xs text-gray-500 ml-3 shrink-0">
                  R$ {item.ultimoValor.toFixed(2)}
                </span>
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
